import { ReactNode, useMemo } from 'react';

// eslint-disable-next-line no-restricted-imports
import { TooltipProps as BaseTooltipProps } from '@mui/material';

import { TooltipStyled } from './Tooltip.styles';
import { TooltipClasses, TooltipProps } from './types';

/**
 * Tooltip component.
 */
export const Tooltip = (props: TooltipProps) => {
  const { type, title, children, arrow, className, placement = 'top' } = props;

  const commonProps: Partial<BaseTooltipProps> & { title: string | ReactNode } =
    useMemo(
      () => ({
        arrow,
        classes: {
          arrow: TooltipClasses.arrow.name,
          tooltip: TooltipClasses.tooltip.name,
        },
        className,
        placement,
        slotProps: {
          popper: !arrow
            ? {
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [0, -8],
                    },
                  },
                ],
              }
            : undefined,
        },
        title,
      }),
      [arrow, className, placement, title]
    );

  if (!title) return children;

  switch (type) {
    case 'click': {
      const { open, onClose } = props;

      return (
        <TooltipStyled
          {...commonProps}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          open={open}
          onClose={onClose}
        >
          {children}
        </TooltipStyled>
      );
    }

    case 'hover':
    default:
      return <TooltipStyled {...commonProps}>{children}</TooltipStyled>;
  }
};

Tooltip.classes = TooltipClasses;
